import React, { useState } from "react";
import { Box } from "@material-ui/core";
import FinancialDashboard from "./FinancialDashboard";
import FinancialEntryForm from "./FinancialEntryForm";
import CreatePaymentChallan from "./CreatePaymentChallan";

export default function FinancialContainer({ profile }) {
  const [screen, setScreen] = useState("list"); // "list" | "create" | "edit" | "create-challan"
  const [editingEntry, setEditingEntry] = useState(null);

  const handleCreate = () => {
    setEditingEntry(null);
    setScreen("create");
  };

  const handleCreateChallan = () => setScreen("create-challan");

  const handleEdit = (entry) => {
    setEditingEntry(entry);
    setScreen("edit");
  };

  const handleCancel = () => setScreen("list");
  const handleSubmitSuccess = () => setScreen("list");

  const handleChallanDone = () => setScreen("list");

  return (
    <Box p={3} textAlign="left">
      {screen === "list" && (
        <FinancialDashboard
          onCreate={handleCreate}
          onCreateChallan={handleCreateChallan}
          onEdit={handleEdit}
        />
      )}
      {(screen === "create" || screen === "edit") && (
        <FinancialEntryForm
          profile={profile}
          initialValues={editingEntry}
          mode={screen}
          onSubmitSuccess={handleSubmitSuccess}
          onCancel={handleCancel}
        />
      )}
      {screen === "create-challan" && (
        <CreatePaymentChallan onDone={handleChallanDone} onCancel={handleCancel} />
      )}
    </Box>
  );
}
